import { types } from '../actions/ProductionActions';
import createShapes from '../components/utils/CreateShapes';
import storeManager from '../store/StoreManager';
import slidesUtils from '../components/utils/SlidesUtils';
import moodsUtils from '../components/utils/MoodsUtils';
import shapeTypes from '../constants/ShapeConstants';
import uuid from 'uuid';
import configuration from '../constants/Configuration';
import appParameters from '../components/utils/AppParameters';
import textSizeUtils from '../components/utils/TextSizeUtils';
import animationManager from "../components/utils/AnimationManager";

function createSlideModel (videoModel) {
    var slide = {};
    var backgroundModel;

    if (videoModel) {
        backgroundModel = createShapes.createBackgroundWithVideo(videoModel);
    } else {
        backgroundModel = createShapes.createBackground();
    }

    slide.content = [backgroundModel];
    slide.initialized = true;
    slide.time = configuration.SLIDE_DURATION;
    slide.uuid = uuid.v4();
    slide.contentItemId = -1; // contentItemId for sound
    slide.sound = '';
    slide.soundEffect = '';
    slide.soundVolume = 0.5;
    slide.soundEffectVolume = 0.5;

    if (videoModel)
        slide.time = videoModel.outPoint - videoModel.inPoint;

    return slide;
}

function addSlide(state, index) {
    let slides = state.slides;
    const slide = createSlideModel();

    slides.splice(index, 0, slide);

    return Object.assign({}, state, {
        slides: slides
    });
}

function addSplittedSlide(state, index, videoModel) {
    let slides = state.slides;
    const slide = createSlideModel(videoModel);

    slides.splice(index, 0, slide);

    return Object.assign({}, state, {
        slides: slides
    });
}

function updateCurrentSlide(state) {
    let slides = state.slides;
    let currentSlide = storeManager.getState().currentSlide;
    let slideModel = currentSlide.model;

    slides[currentSlide.currentSlideIndex] = slideModel;

    return Object.assign({}, state, {
        slides: slides
    });
}

// drag target should be inserted before dropIndex
function changeSlidePosition(state, dragIndex, dropIndex) {
    let slides = state.slides;
    let newSlides = [];
    let i;
    let target = slides[dragIndex];

    if (target == undefined || dropIndex < 0 || dragIndex == dropIndex)
        newSlides = slides;
    else {
        const dropTarget = slides[dropIndex];

        for (i = 0; i < slides.length; i++) {

            if (i == dragIndex)
                continue;

            newSlides.push(slides[i]);
        }

        if (dropIndex >= slides.length - 1)
            newSlides.push(target);
        else {
            var dropTargetIndex = newSlides.indexOf(dropTarget);
            newSlides.splice(dropTargetIndex, 0, target);
        }
    }

    return Object.assign({}, state, {
        slides: newSlides
    });
}

function shiftSlide(state, isLeft, currentPosition) {
    let slides = state.slides;
    let newSlides = [];
    let i;
    let limit;

    // first limit -- the left one
    if (isLeft == true) {
        limit = currentPosition - 1;
    }
    else {
        limit = currentPosition;
    }

    for (i=0; i<limit; i++) {
        newSlides.push(slides[i]);
    }

    // second limit -- the right one
    if (isLeft == true) {
        limit = currentPosition;
        newSlides.push(slides[currentPosition]);
        newSlides.push(slides[currentPosition - 1]);
    }
    else {
        limit = currentPosition + 1;
        newSlides.push(slides[currentPosition + 1]);
        newSlides.push(slides[currentPosition]);
    }

    for (i=limit+1; i<slides.length; i++) {
        newSlides.push(slides[i]);
    }

    return Object.assign({}, state, {
        slides: newSlides
    });
}

function updateProductionMoods(state) {
    const slides = state.slides;
    var newSlides = [];
    var i;
    var slide;

    for (i=0; i<slides.length; i++) {
        slide = Object.assign({}, slides[i]);

        var shapes = slide.content;
        var j;
        var shape;
        var newShapes = [];

        for (j=0; j<shapes.length; j++) {
            shape = shapes[j];

            if (shape.type == shapeTypes.CHARACTER || shape.type == shapeTypes.BACKGROUND) {
                shape = Object.assign({}, shape);
                shape.moods = moodsUtils.getMoods(shape.logicalName);

                if (shape.type == shapeTypes.BACKGROUND && shape.moods && shape.moods.length > 0) {
                    if (shape.logicalName != undefined && shape.logicalName.length > 0 && (shape.frameLabel == undefined || shape.frameLabel.length < 1))
                        shape.frameLabel = 'dag';
                        shape.xlinkHref = appParameters.SVG_URL() + `${shape.logicalName}_${shape.frameLabel}.svg`;
                }
            }

            newShapes.push(shape);
        }

        slide.content = newShapes;
        newSlides.push(slide);
    }

    return Object.assign({}, state, {
        slides: newSlides
    });
}

function deleteSlide(state) {
    let slides = state.slides;
    const currentSlideIndex = storeManager.getState().currentSlide.currentSlideIndex;

    slides.splice(currentSlideIndex, 1);

    if (slides.length == 0) {
        const slide = createSlideModel();
        slide.isClone = true;
        slide.initialized = false;
        slides.push(slide);
    }

    return Object.assign({}, state, {
        slides: slides
    });
}

function setWindowSize(state, width, height) {
    return Object.assign({}, state, {windowWidth: width, windowHeight: height});
}

function changeMode(state, mode) {
    return Object.assign({}, state, {
        mode: mode
    });
}

function setSlideCloneTarget(state, slide) {
    return Object.assign({}, state, {
        slideCloneTarget: slide
    });
}

function duplicateSlideAtEndOfAnimation(state) {
    const slides = state.slides;
    const currentSlideIndex = storeManager.getState().currentSlide.currentSlideIndex;
    const currentSlide = storeManager.getState().currentSlide;

    let newSlide = {};
    newSlide.initialized = false;
    newSlide.time = currentSlide.model.time;
    newSlide.uuid = uuid.v4();

    const shapes = currentSlide.model.content;

    const newShapes = shapes.map(shape => {
        const newShape = JSON.parse(JSON.stringify(shape));
        newShape.uuid = uuid.v4();

        if (newShape.animation) {
            let animationPoints = animationManager.getAnimationPoints(newShape.animation);
            let animationStart = animationPoints[animationPoints.length - 2];
            let animationEnd = animationPoints[animationPoints.length - 1];

            if (newShape.type == shapeTypes.LINE || newShape.type == shapeTypes.CURVE) {
                if (animationEnd.x1)
                    newShape.x1 = animationEnd.x1;

                if (animationEnd.y1)
                    newShape.y1 = animationEnd.y1;

                if (animationEnd.x2)
                    newShape.x2 = animationEnd.x2;

                if (animationEnd.y2)
                    newShape.y2 = animationEnd.y2;

                if (newShape.type == shapeTypes.CURVE) {
                    if (animationEnd.cx)
                        newShape.cx = animationEnd.cx;

                    if (animationEnd.cy)
                        newShape.cy = animationEnd.cy;
                }
            } else {
                if (animationEnd.x)
                    newShape.x = animationEnd.x;

                if (animationEnd.y)
                    newShape.y = animationEnd.y;

                if (animationEnd.width)
                    newShape.width = animationEnd.width;

                if (animationEnd.height)
                    newShape.height = animationEnd.height;

                if (newShape.type == shapeTypes.SPEAK_BUBBLE || newShape.type == shapeTypes.COMPLEX_SPEAK_BUBBLE || newShape.type == shapeTypes.SCREAM_BUBBLE || newShape.type == shapeTypes.THOUGHT_BUBBLE) {
                    if (animationEnd.cx)
                        newShape.cx = animationEnd.cx;

                    if (animationEnd.cy)
                        newShape.cy = animationEnd.cy;

                    if (animationEnd.cx1)
                        newShape.cx1 = animationEnd.cx1;

                    if (animationEnd.cy1)
                        newShape.cy1 = animationEnd.cy1;

                    if (animationEnd.cx2)
                        newShape.cx2 = animationEnd.cx2;

                    if (animationEnd.cy2)
                        newShape.cy2 = animationEnd.cy2;

                    if (animationEnd.cx3)
                        newShape.cx3 = animationEnd.cx3;

                    if (animationEnd.cy3)
                        newShape.cy3 = animationEnd.cy3;

                    if (animationEnd.cx4)
                        newShape.cx4 = animationEnd.cx4;

                    if (animationEnd.cy4)
                        newShape.cy4 = animationEnd.cy4;

                    if (animationEnd.cx5)
                        newShape.cx5 = animationEnd.cx5;

                    if (animationEnd.cy5)
                        newShape.cy5 = animationEnd.cy5;
                }

                if (newShape.type == shapeTypes.SPEAK_BUBBLE || newShape.type == shapeTypes.COMPLEX_SPEAK_BUBBLE || newShape.type == shapeTypes.SCREAM_BUBBLE || newShape.type == shapeTypes.THOUGHT_BUBBLE || newShape.type == shapeTypes.TEXTBOX || newShape.type == shapeTypes.TEXTBOXSIMPLE)
                    newShape.fontSize = textSizeUtils.getFontSize(newShape, newShape.width, newShape.height, animationStart.width, animationStart.height);
            }

            if (animationEnd.opacity >= 0)
                newShape.opacity = animationEnd.opacity;

            if (animationEnd.rotation >= 0)
                newShape.rotation = animationEnd.rotation;

            newShape.animation = undefined;
        }

        return newShape;
    });

    newSlide.content = newShapes;

    slides.splice(currentSlideIndex + 1, 0, newSlide);

    return Object.assign({}, state, {
        slides: slides
    });
}

function duplicateSlide(state) {
    const slides = state.slides;
    const currentSlideIndex = storeManager.getState().currentSlide.currentSlideIndex;
    const currentSlide = storeManager.getState().currentSlide;

    let newSlide = {};
    newSlide.initialized = false;
    newSlide.time = currentSlide.model.time;
    newSlide.uuid = uuid.v4();

    const shapes = currentSlide.model.content;
    let mindMapsUidsList = [];

    const newShapes = shapes.map(shape => {
        const newShape = JSON.parse(JSON.stringify(shape));

        const newUid = uuid.v4();

        if (shape.isMindMap)
            mindMapsUidsList[shape.uuid] = newUid;
        else {
            if (shape.mindMapProperty && mindMapsUidsList[shape.mindMapProperty.parentMindMap])
                    newShape.mindMapProperty.parentMindMap = mindMapsUidsList[shape.mindMapProperty.parentMindMap];
        }

        newShape.uuid = newUid;
        return newShape;
    });

    newSlide.content = newShapes;

    slides.splice(currentSlideIndex + 1, 0, newSlide);

    return Object.assign({}, state, {
        slides: slides
    });
}

function cloneSlide(state, target) {
    const slides = state.slides;
    const currentSlideIndex = storeManager.getState().currentSlide.currentSlideIndex;
    const currentSlide = storeManager.getState().currentSlide;

    let newSlide = {};
    newSlide.title = slidesUtils.generateSlideTitle(slides);
    newSlide.initialized = false;
    newSlide.time = currentSlide.model.time;

    const shapes = target.content;
    let mindMapsUidsList = [];

    const newShapes = shapes.map(shape => {
        const newShape = JSON.parse(JSON.stringify(shape));

        const newUid = uuid.v4();

        if (shape.isMindMap)
            mindMapsUidsList[shape.uuid] = newUid;
        else {
            if (shape.mindMapProperty && mindMapsUidsList[shape.mindMapProperty.parentMindMap])
                newShape.mindMapProperty.parentMindMap = mindMapsUidsList[shape.mindMapProperty.parentMindMap];
        }

        newShape.uuid = newUid;
        return newShape;
    });

    newSlide.content = newShapes;

    slides.splice(currentSlideIndex + 1, 0, newSlide);

    return Object.assign({}, state, {
        slides: slides
    });
}

function productionUndoRedoAction (state, appState) {
    const newProductionState = appState.production;

    return Object.assign({}, state, {
        slides: newProductionState.slides,
        storySound: newProductionState.storySound
    });
}

function addStorySound (state, audioItem) {
    if (audioItem.contentItemId < 1000)
        audioItem.contentItemId = -1;

    return Object.assign({}, state, {
        storySound: audioItem
    });
}

function changeStorySoundVolume (state, volume) {
    return Object.assign({}, state, {
        storySoundVolume: volume
    });
}

function setExportProperties (state, properties) {
    return Object.assign({}, state, {
        exportProperties: properties
    });
}

function changeSlideProperty (state, uuid, propertyType, propertyValue) {
    const slides = state.slides;
    var newSlides = [];
    var i;
    var slide;

    for (i=0; i<slides.length; i++) {
        slide = Object.assign({}, slides[i]);

        if (slide.uuid == uuid) {
            if (propertyType == 'sound') {
                if (propertyValue.href == '') {
                    slide.contentItemId = -1;
                    slide.sound = '';
                    slide.soundWav = '';
                    slide.soundTitle = '';
                } else {
                    if (propertyValue.contentItemId == -1) {
                        slide.contentItemId = propertyValue.contentItemId;
                        slide.soundWav = propertyValue.href;
                        slide.soundTitle = propertyValue.title;
                    } else {
                        slide.contentItemId = propertyValue.contentItemId;
                        slide.sound = propertyValue.href;
                        slide.soundTitle = propertyValue.title;
                    }
                }
            } else {
                if (!slide.content[0].isVideo) // if the video is attached to a slide then, the duration shouldn't be changed by a sound
                    slide.time = propertyValue;
            }
        }

        newSlides.push(slide);
    }

    return Object.assign({}, state, {
        slides: newSlides
    });
}

export default function(state = {}, action) {

    switch (action.type) {
        case types.LOADED_NEW_PRODUCTION:
            return Object.assign({}, state, action.production);

        case types.LOADED_OLD_PRODUCTION:
            return Object.assign({}, state, action.production);

        case types.CONTENT_XML_LOADED:
            return Object.assign({}, state, {data: action.data});

        case types.ADD_SLIDE:
            return addSlide(state, action.index);

        case types.ADD_SPLITTED_SLIDE:
            return addSplittedSlide(state, action.index, action.videoModel);

        case types.UPDATE_CURRENT_SLIDE:
            return updateCurrentSlide(state);

        case types.CHANGE_SLIDE_POSITION:
            return changeSlidePosition(state, action.startPosition, action.endPosition);

        case types.DUPLICATE_SLIDE:
            return duplicateSlide(state);

        case types.DUPLICATE_SLIDE_END_ANIMATION:
            return duplicateSlideAtEndOfAnimation(state);

        case types.DELETE_SLIDE:
            return deleteSlide(state);

        case types.SET_WINDOW_SIZE:
            return setWindowSize(state, action.width, action.height);

        case types.CHANGE_MODE:
            return changeMode(state, action.mode);

        case types.SHIFT_SLIDE:
            return shiftSlide(state, action.isLeft, action.currentPosition);

        case types.SET_SLIDE_CLONE_TARGET:
            return setSlideCloneTarget(state, action.slide);

        case types.CLONE_SLIDE:
            return cloneSlide(state, action.target);

        case types.PRODUCTION_UNDO_REDO_ACTION:
            return productionUndoRedoAction(state, action.newState);

        case types.ADD_STORY_SOUND:
            return addStorySound(state, action.audioItem);

        case types.CHANGE_STORY_SOUND_VOLUME:
            return changeStorySoundVolume(state, action.volume);

        case types.UPDATE_PRODUCTION_MOODS:
            return updateProductionMoods(state);

        case types.CHANGE_SLIDE_PROPERTY:
            return changeSlideProperty(state, action.uuid, action.propertyType, action.propertyValue);

        case types.SET_EXPORT_PROPERTIES:
            return setExportProperties(state, action.properties);

        default:
            return state;
    }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/ProductionReducer.js
 **/